import TripsScreen from "../Trips/TripsScreen";

const DesktopTrips = ({ currentUser, forceView, onViewApplied, onNavigateChat, onOpenChat }) => (
  <div className="d-page">
    <div className="d-container">
      <TripsScreen
        currentUser={currentUser}
        forceView={forceView}
        onViewApplied={onViewApplied}
        onNavigateChat={onNavigateChat}
        onOpenChat={onOpenChat}
      />
    </div>
  </div>
);

export default DesktopTrips;
